import { msg } from '@lingui/macro'

import * as React from 'react'

import { LinguiMessageDescriptor, useTrans } from '../../i18n/useTrans'

/**
 * Returns the `buildError` function to build an error message.
 *
 * It accepts a translated message (type of lingui message descriptor) and returns it with a generic error message.
 * Uses the `useTrans` hook to translate the message.
 *
 */
export const useBuildError = () => {
  const { trans } = useTrans()

  const buildError = React.useCallback(
    (message: LinguiMessageDescriptor) => {
      const translatedMessage = trans(message)
      const translatedAppendedMessage = trans(msg`Our team was notified about the issue.`)

      return `${translatedMessage} ${translatedAppendedMessage}`
    },
    [trans],
  )

  return { buildError }
}
